import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { fuseAnimations } from '../../../../../../../../../core/animations';

/**Local files */
import { displayValues, spekwo } from '../../../../../../utils/index';


/** Service file */
import { AssignProService } from '../../../../../assignPro/assignPro.service';
import { SideNavService } from '../../../sidenav.service';

@Component({
    selector: 'user-info-main',
    templateUrl: './userInfoMain.component.html',
    styleUrls: ['./userInfoMain.component.scss'],
    animations: fuseAnimations
})

export class UserInfoMainComponent {

    displayValues = displayValues;
    spekwo = spekwo;

    constructor(
        public location: Location,
        /** Service file */
        public assignProService: AssignProService,
        public sideNavService: SideNavService
    ) {
        this.assignProService.GetAllProUsers(this.spekwo.Pro);
    }

    ngOnInit() {

    }

    ngOnDestroy() {

    }

    /** Apply filter */

    applyFilter(filterValue: string) {
        this.sideNavService.onProInfoFiltered.next(filterValue);
    }

    goback() {
        this.location.back();
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/pros/user-info/userInfoMain.component.ts